import { render, staticRenderFns } from "./mycert_detail.vue?vue&type=template&id=2a679262&scoped=true&"
import script from "./mycert_detail.vue?vue&type=script&lang=js&"
export * from "./mycert_detail.vue?vue&type=script&lang=js&"
import style0 from "./mycert_detail.vue?vue&type=style&index=0&id=2a679262&prod&lang=less&"
import style1 from "./mycert_detail.vue?vue&type=style&index=1&id=2a679262&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a679262",
  null
  
)

export default component.exports